import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
import { spotFinder } from './endpoints';

export const labourJobApi = createApi({
  reducerPath: 'labourJobApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['labourJob'],
  endpoints: (builder) => ({
    getAllLabourServiceDetails: builder.mutation({
      query(body) {
        return {
          url: spotFinder.labourServiceDetailController.getAllLabourServiceDetails,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    getLabourServiceDetailById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.labourServiceDetailController.getLabourServiceDetailById}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    createLabourServiceDetail: builder.mutation({
        query(body) {
            return {
              url: body.payload.isEdit
                ? `${spotFinder.labourServiceDetailController.updateLabourServiceDetail}${body.payload.id}` 
                : spotFinder.labourServiceDetailController.createLabourServiceDetail, 
              method: body.payload.isEdit ? 'PUT' : 'POST',
              headers: { Authorization: `Bearer ${body.token}` }, 
              body: body.payload, // Pass the payload as the body
            };
          },
      }),
    updateLabourServiceDetail: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? `${spotFinder.labourServiceDetailController.updateLabourServiceDetail}${body.payload.id}`
            : spotFinder.labourServiceDetailController.createLabourServiceDetail,
          method: body.payload.isEdit ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});


export const {
  useGetAllLabourServiceDetailsMutation,
  useGetLabourServiceDetailByIdMutation,
  useCreateLabourServiceDetailMutation,
  useUpdateLabourServiceDetailMutation,
} = labourJobApi;
